export const alertTypes = {
    alertLoad: "[Alerts] Load alerts",
    alertDelete: "[Alerts] Delete alerts",
};
